import React from 'react';
import { GRID_SIZE, COLORS } from '../../lib/network/constants';

const DOT_RADIUS = 2;
/** When zoomed out, skip every other world line so screen spacing stays readable. */
const MIN_SCREEN_STEP = 28;

/** Screen-space step that stays on the world grid (50, 100, 200, …). */
export const gridStep = (k, gridSize = GRID_SIZE) => {
  const scale = k || 1;
  let worldStep = gridSize;
  while (worldStep * scale < MIN_SCREEN_STEP) worldStep *= 2;
  return { worldStep, step: worldStep * scale };
};

/** Dot grid drawn in screen space, aligned with the world grid under `transform`. */
export default function Grid({ transform }) {
  const { step } = gridStep(transform.k);
  const ox = ((transform.x % step) + step) % step;
  const oy = ((transform.y % step) + step) % step;
  return (
    <g data-layer="grid" pointerEvents="none">
      <defs>
        <pattern
          id="grid-dots"
          x={ox - step / 2}
          y={oy - step / 2}
          width={step}
          height={step}
          patternUnits="userSpaceOnUse"
        >
          <circle cx={step / 2} cy={step / 2} r={DOT_RADIUS} fill={COLORS.grid} />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid-dots)" />
    </g>
  );
}
